import './NotificationList.css';
import React, { useState } from "react";
import {
  markNotificationAsRead,
  useNotifications,
  clearAllNotification
} from "../../API/Notification";
import storage from "@utils/storage";
import { useNavigate } from "react-router-dom";
import { useSocket } from "@utils/socket/socketContext";
import NotificationIcon from "../../../src/Assets/Images/bell-icon.svg";
import CrossIcon from "../../../src/Assets/Images/Mask group.svg";

const NotificationList = () => {
  const Id = storage.getUser();
  const [readNotifications, setReadNotifications] = useState<Set<string>>(new Set());
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const { socket } = useSocket();

  // Custom hook for fetching notifications
  const { data: notifications, isLoading, refetch } = useNotifications({
    userType: Id.role,
    userId: Id.user.userId,
    config: {
      refetchInterval: 3000,
    },
  });
  const getRouteFromTitle = (title: string) => {
    const normalized = title.toLowerCase().trim();

    if (normalized.includes("new offer")) return "/app/browse-offers";
    if (normalized.includes("new application")) return "/app/open-offers";
    if (normalized.includes("approved")) return "/app/approved-applications";
    if (normalized.includes("rejected")) return "/app/rejected-applications";
    if (normalized.includes("underreview")) return "/app/underReview-applications";
    return;
  };

  const handleNotificationClick = async (notificationUuid: string, title: string) => {
    try {
      await markNotificationAsRead(notificationUuid);
      setReadNotifications((prev) => new Set(prev).add(notificationUuid));

      // 🔥 Emit to socket for real-time count update
      if (socket?.connected && Id.user?.userId) {
        socket.emit("get notification count", Id.user.userId); // Simply re-trigger count
      }

      const route = getRouteFromTitle(title);
      if (route) navigate(route);
    } catch (error) {
      console.error("Failed to mark notification as read", error);
    }
  };

  const handleClearAll = async () => {
    try {
      await clearAllNotification();

      // Optionally clear local read state
      setReadNotifications(new Set());
      refetch();

      // Emit socket event to update notification count globally
      if (socket?.connected && Id.user?.userId) {
        socket.emit("get notification count", Id.user.userId);
      }

      // You can refetch notifications manually if needed
      // Or rely on `refetchInterval` from `useNotifications`
    } catch (error) {
      console.error("Failed to clear all notifications", error);
    }
  };




  // Filtered notifications based on search query
  const filteredNotifications = notifications?.filter((notification) =>
    notification.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
    notification.notification.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="content">
      <div className="content-wrapper notification-section">
        <div className="title-search-block d-flex align-items-center justify-content-between">
          <h5 className="m-0">All Notifications</h5>

        </div>

        <div className="outer-box-wrapper">
          <div className="input-btn-fields spacing-bottom d-flex align-items-center justify-content-between">
            <div className="search-box">
              <div className="input-search position-relative">
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <div className="search-icon position-absolute">
                  {/* Search Icon SVG */}
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13 13L9 9M1 5.66667C1 6.2795 1.12071 6.88634 1.35523 7.45252C1.58975 8.01871 1.93349 8.53316 2.36683 8.9665C2.80018 9.39984 3.31462 9.74358 3.88081 9.97811C4.447 10.2126 5.05383 10.3333 5.66667 10.3333C6.2795 10.3333 6.88634 10.2126 7.45252 9.97811C8.01871 9.74358 8.53316 9.39984 8.9665 8.9665C9.39984 8.53316 9.74358 8.01871 9.97811 7.45252C10.2126 6.88634 10.3333 6.2795 10.3333 5.66667C10.3333 5.05383 10.2126 4.447 9.97811 3.88081C9.74358 3.31462 9.39984 2.80018 8.9665 2.36683C8.53316 1.93349 8.01871 1.58975 7.45252 1.35523C6.88634 1.12071 6.2795 1 5.66667 1C5.05383 1 4.447 1.12071 3.88081 1.35523C3.31462 1.58975 2.80018 1.93349 2.36683 2.36683C1.93349 2.80018 1.58975 3.31462 1.35523 3.88081C1.12071 4.447 1 5.05383 1 5.66667Z"
                      stroke="#8F95A2"
                      strokeWidth="1.25"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                </div>
              </div>
            </div>
            <button className="clear-all" onClick={handleClearAll}>
              <img src={CrossIcon} alt="cross-icon" />
              Clear all
            </button>
          </div>
          <ul className="ul p-0 m-0 list-unstyled notification-listing d-flex flex-column">
            {isLoading ? (
              Array.from({ length: 0 }).map((_, idx) => (
                <li key={idx} className="list-new">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.0127 0H3.23145C2.45604 0 1.8252 0.630844 1.8252 1.40625V6.1875C1.8252 6.44639 2.0351 6.65625 2.29395 6.65625C2.55279 6.65625 2.7627 6.44639 2.7627 6.1875V1.40625C2.7627 1.14778 2.97298 0.9375 3.23145 0.9375H17.0127C17.2712 0.9375 17.4814 1.14778 17.4814 1.40625V18.8438C17.4814 19.1022 17.2712 19.3125 17.0127 19.3125H3.23145C2.97298 19.3125 2.7627 19.1022 2.7627 18.8438V10.1406C2.7627 9.88172 2.55279 9.67186 2.29395 9.67186C2.0351 9.67186 1.8252 9.88172 1.8252 10.1406V18.8438C1.8252 19.6192 2.45604 20.25 3.23145 20.25H17.0127C17.7881 20.25 18.4189 19.6192 18.4189 18.8438V1.40625C18.4189 0.630844 17.7881 0 17.0127 0Z"
                      fill="#00B8D9"
                    />
                    <path
                      d="M2.6253 7.95466C2.53816 7.86748 2.41723 7.81779 2.29395 7.81779C2.17066 7.81779 2.04973 7.86748 1.96254 7.95466C1.87509 8.04286 1.82577 8.16187 1.8252 8.28607C1.82561 8.41044 1.87494 8.52965 1.96254 8.61795C2.04973 8.70513 2.17066 8.75529 2.29395 8.75529C2.41718 8.75529 2.53812 8.70513 2.6253 8.61795C2.71301 8.52973 2.76238 8.41047 2.7627 8.28607C2.7627 8.16279 2.71249 8.04232 2.6253 7.95466ZM4.50312 21.3276C4.41507 21.24 4.29596 21.1906 4.17171 21.1903C4.04843 21.1903 3.92749 21.2404 3.84035 21.3276C3.75273 21.4157 3.70337 21.5348 3.70296 21.659C3.70296 21.7828 3.75316 21.9033 3.84035 21.9904C3.92831 22.0782 4.04745 22.1276 4.17171 22.1278C4.29551 22.1278 4.41593 22.0781 4.50312 21.9904C4.5908 21.9024 4.64016 21.7833 4.64046 21.659C4.64046 21.5358 4.5903 21.4148 4.50312 21.3276ZM19.8281 1.87793C19.5693 1.87793 19.3594 2.08779 19.3594 2.34668V20.7217C19.3594 20.9801 19.1491 21.1904 18.8906 21.1904H6.0469C5.78805 21.1904 5.57815 21.4003 5.57815 21.6592C5.57815 21.9181 5.78805 22.1279 6.0469 22.1279H18.8906C19.6661 22.1279 20.2969 21.4971 20.2969 20.7217V2.34668C20.2969 2.08779 20.087 1.87793 19.8281 1.87793Z"
                      fill="#00B8D9"
                    />
                    <path
                      d="M21.7061 3.75C21.4473 3.75 21.2374 3.95986 21.2374 4.21875V22.5938C21.2374 22.8522 21.0271 23.0625 20.7686 23.0625H6.04985C5.79101 23.0625 5.5811 23.2724 5.5811 23.5312C5.5811 23.7901 5.79101 24 6.04985 24H20.7686C21.544 24 22.1749 23.3692 22.1749 22.5938V4.21875C22.1749 3.95986 21.9649 3.75 21.7061 3.75ZM9.41895 3.46875H4.91895C4.6601 3.46875 4.4502 3.67861 4.4502 3.9375V8.4375C4.4502 8.69639 4.6601 8.90625 4.91895 8.90625H9.41895C9.67779 8.90625 9.8877 8.69639 9.8877 8.4375V3.9375C9.8877 3.67861 9.67779 3.46875 9.41895 3.46875ZM8.9502 7.96875H5.3877V4.40625H8.9502V7.96875ZM7.9107 11.0345C7.7276 10.8515 7.43088 10.8514 7.24774 11.0345L6.00166 12.2805L5.42229 11.7011C5.23924 11.5181 4.94252 11.5181 4.75934 11.7011C4.57629 11.8842 4.57629 12.181 4.75934 12.364L5.67021 13.2749C5.75814 13.3628 5.87737 13.4122 6.00169 13.4122C6.12601 13.4122 6.24524 13.3628 6.33316 13.2749L7.9107 11.6974C8.09374 11.5143 8.09374 11.2175 7.9107 11.0345Z"
                      fill="#00B8D9"
                    />
                    <path
                      d="M15.5909 11.6719H10.1221C9.86325 11.6719 9.65334 11.8817 9.65334 12.1406C9.65334 12.3995 9.86325 12.6094 10.1221 12.6094H15.5909C15.8497 12.6094 16.0596 12.3995 16.0596 12.1406C16.0596 11.8817 15.8497 11.6719 15.5909 11.6719ZM15.3252 3.46875H12.044C11.7851 3.46875 11.5752 3.67861 11.5752 3.9375C11.5752 4.19639 11.7851 4.40625 12.044 4.40625H15.3252C15.5841 4.40625 15.794 4.19639 15.794 3.9375C15.794 3.67861 15.5841 3.46875 15.3252 3.46875ZM15.3252 5.71875H12.044C11.7851 5.71875 11.5752 5.92861 11.5752 6.1875C11.5752 6.44639 11.7851 6.65625 12.044 6.65625H15.3252C15.5841 6.65625 15.794 6.44639 15.794 6.1875C15.794 5.92861 15.5841 5.71875 15.3252 5.71875ZM15.3252 7.96875H12.044C11.7851 7.96875 11.5752 8.17861 11.5752 8.4375C11.5752 8.69639 11.7851 8.90625 12.044 8.90625H15.3252C15.5841 8.90625 15.794 8.69639 15.794 8.4375C15.794 8.17861 15.5841 7.96875 15.3252 7.96875ZM7.91072 14.6142C7.72762 14.4312 7.4309 14.4311 7.24776 14.6142L6.00168 15.8602L5.42231 15.2808C5.23926 15.0978 4.94254 15.0978 4.75936 15.2808C4.57631 15.4639 4.57631 15.7607 4.75936 15.9437L5.67023 16.8546C5.75816 16.9425 5.87739 16.9919 6.00171 16.9919C6.12603 16.9919 6.24526 16.9425 6.33318 16.8546L7.91072 15.2771C8.09376 15.094 8.09376 14.7972 7.91072 14.6142ZM15.5909 15.2344H10.1221C9.86325 15.2344 9.65334 15.4442 9.65334 15.7031C9.65334 15.962 9.86325 16.1719 10.1221 16.1719H15.5909C15.8497 16.1719 16.0596 15.962 16.0596 15.7031C16.0596 15.4442 15.8497 15.2344 15.5909 15.2344Z"
                      fill="#00B8D9"
                    />
                  </svg>
                </li>
              ))
            ) : filteredNotifications && filteredNotifications.length > 0 ? (
              filteredNotifications.map((notification) => (
                <li
                  key={notification.uuid}
                  className={`list-new ${notification.isRead || readNotifications.has(notification.uuid)
                    ? "read"
                    : ""
                    }`}
                  onClick={() => handleNotificationClick(notification.uuid, notification.title)}
                >
                  <div className="d-flex align-items-start listing-box gap-3">
                    <div className="d-flex align-items-center gap-3">
                      <div className="notification-icon-new">
                        {/* <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.0127 0H3.23145C2.45604 0 1.8252 0.630844 1.8252 1.40625V6.1875C1.8252 6.44639 2.0351 6.65625 2.29395 6.65625C2.55279 6.65625 2.7627 6.44639 2.7627 6.1875V1.40625C2.7627 1.14778 2.97298 0.9375 3.23145 0.9375H17.0127C17.2712 0.9375 17.4814 1.14778 17.4814 1.40625V18.8438C17.4814 19.1022 17.2712 19.3125 17.0127 19.3125H3.23145C2.97298 19.3125 2.7627 19.1022 2.7627 18.8438V10.1406C2.7627 9.88172 2.55279 9.67186 2.29395 9.67186C2.0351 9.67186 1.8252 9.88172 1.8252 10.1406V18.8438C1.8252 19.6192 2.45604 20.25 3.23145 20.25H17.0127C17.7881 20.25 18.4189 19.6192 18.4189 18.8438V1.40625C18.4189 0.630844 17.7881 0 17.0127 0Z"
                            fill="#00B8D9"
                          />
                          <path
                            d="M2.6253 7.95466C2.53816 7.86748 2.41723 7.81779 2.29395 7.81779C2.17066 7.81779 2.04973 7.86748 1.96254 7.95466C1.87509 8.04286 1.82577 8.16187 1.8252 8.28607C1.82561 8.41044 1.87494 8.52965 1.96254 8.61795C2.04973 8.70513 2.17066 8.75529 2.29395 8.75529C2.41718 8.75529 2.53812 8.70513 2.6253 8.61795C2.71301 8.52973 2.76238 8.41047 2.7627 8.28607C2.7627 8.16279 2.71249 8.04232 2.6253 7.95466ZM4.50312 21.3276C4.41507 21.24 4.29596 21.1906 4.17171 21.1903C4.04843 21.1903 3.92749 21.2404 3.84035 21.3276C3.75273 21.4157 3.70337 21.5348 3.70296 21.659C3.70296 21.7828 3.75316 21.9033 3.84035 21.9904C3.92831 22.0782 4.04745 22.1276 4.17171 22.1278C4.29551 22.1278 4.41593 22.0781 4.50312 21.9904C4.5908 21.9024 4.64016 21.7833 4.64046 21.659C4.64046 21.5358 4.5903 21.4148 4.50312 21.3276ZM19.8281 1.87793C19.5693 1.87793 19.3594 2.08779 19.3594 2.34668V20.7217C19.3594 20.9801 19.1491 21.1904 18.8906 21.1904H6.0469C5.78805 21.1904 5.57815 21.4003 5.57815 21.6592C5.57815 21.9181 5.78805 22.1279 6.0469 22.1279H18.8906C19.6661 22.1279 20.2969 21.4971 20.2969 20.7217V2.34668C20.2969 2.08779 20.087 1.87793 19.8281 1.87793Z"
                            fill="#00B8D9"
                          />
                          <path
                            d="M21.7061 3.75C21.4473 3.75 21.2374 3.95986 21.2374 4.21875V22.5938C21.2374 22.8522 21.0271 23.0625 20.7686 23.0625H6.04985C5.79101 23.0625 5.5811 23.2724 5.5811 23.5312C5.5811 23.7901 5.79101 24 6.04985 24H20.7686C21.544 24 22.1749 23.3692 22.1749 22.5938V4.21875C22.1749 3.95986 21.9649 3.75 21.7061 3.75ZM9.41895 3.46875H4.91895C4.6601 3.46875 4.4502 3.67861 4.4502 3.9375V8.4375C4.4502 8.69639 4.6601 8.90625 4.91895 8.90625H9.41895C9.67779 8.90625 9.8877 8.69639 9.8877 8.4375V3.9375C9.8877 3.67861 9.67779 3.46875 9.41895 3.46875ZM8.9502 7.96875H5.3877V4.40625H8.9502V7.96875ZM7.9107 11.0345C7.7276 10.8515 7.43088 10.8514 7.24774 11.0345L6.00166 12.2805L5.42229 11.7011C5.23924 11.5181 4.94252 11.5181 4.75934 11.7011C4.57629 11.8842 4.57629 12.181 4.75934 12.364L5.67021 13.2749C5.75814 13.3628 5.87737 13.4122 6.00169 13.4122C6.12601 13.4122 6.24524 13.3628 6.33316 13.2749L7.9107 11.6974C8.09374 11.5143 8.09374 11.2175 7.9107 11.0345Z"
                            fill="#00B8D9"
                          />
                          <path
                            d="M15.5909 11.6719H10.1221C9.86325 11.6719 9.65334 11.8817 9.65334 12.1406C9.65334 12.3995 9.86325 12.6094 10.1221 12.6094H15.5909C15.8497 12.6094 16.0596 12.3995 16.0596 12.1406C16.0596 11.8817 15.8497 11.6719 15.5909 11.6719ZM15.3252 3.46875H12.044C11.7851 3.46875 11.5752 3.67861 11.5752 3.9375C11.5752 4.19639 11.7851 4.40625 12.044 4.40625H15.3252C15.5841 4.40625 15.794 4.19639 15.794 3.9375C15.794 3.67861 15.5841 3.46875 15.3252 3.46875ZM15.3252 5.71875H12.044C11.7851 5.71875 11.5752 5.92861 11.5752 6.1875C11.5752 6.44639 11.7851 6.65625 12.044 6.65625H15.3252C15.5841 6.65625 15.794 6.44639 15.794 6.1875C15.794 5.92861 15.5841 5.71875 15.3252 5.71875ZM15.3252 7.96875H12.044C11.7851 7.96875 11.5752 8.17861 11.5752 8.4375C11.5752 8.69639 11.7851 8.90625 12.044 8.90625H15.3252C15.5841 8.90625 15.794 8.69639 15.794 8.4375C15.794 8.17861 15.5841 7.96875 15.3252 7.96875ZM7.91072 14.6142C7.72762 14.4312 7.4309 14.4311 7.24776 14.6142L6.00168 15.8602L5.42231 15.2808C5.23926 15.0978 4.94254 15.0978 4.75936 15.2808C4.57631 15.4639 4.57631 15.7607 4.75936 15.9437L5.67023 16.8546C5.75816 16.9425 5.87739 16.9919 6.00171 16.9919C6.12603 16.9919 6.24526 16.9425 6.33318 16.8546L7.91072 15.2771C8.09376 15.094 8.09376 14.7972 7.91072 14.6142ZM15.5909 15.2344H10.1221C9.86325 15.2344 9.65334 15.4442 9.65334 15.7031C9.65334 15.962 9.86325 16.1719 10.1221 16.1719H15.5909C15.8497 16.1719 16.0596 15.962 16.0596 15.7031C16.0596 15.4442 15.8497 15.2344 15.5909 15.2344Z"
                            fill="#00B8D9"
                          />
                        </svg> */}

                        <img src={NotificationIcon} alt="bell-icon" />

                      </div>
                    </div>
                    <div className="right-content-notify w-100 d-flex align-items-end justify-content-between">
                      <div className="notf-title">
                        <h6 className="m-0">{notification.title}</h6>
                        <p className="m-0">{notification.notification}</p>
                      </div>
                      <div className="time-date text-end">
                        <p className="m-0">
                          {new Date(notification.createdAt).toLocaleString()}
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              ))
            ) : (
              <li className="text-center text-muted py-4">
                No notifications found.
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default NotificationList;
